import Typography from '@mui/material/Typography';
import CustomBox from '../common/CustomBox';
import CustomSubheader from './CustomSubheader';
import './ProviderWhoITreat.scss';

const ProviderWhoITreat = props => {
  const { provider } = props;
  if (!provider.who_i_treat || !provider.who_i_treat.length) return <></>;
  return (
    <CustomBox borderless className='ProviderWhoITreat'>
      <CustomSubheader>
        Who I Treat
      </CustomSubheader>
      <ul>
        {(provider.who_i_treat || []).map((item, i) =>
          <li key={i}>
            <Typography variant='paragraphSmall' lineHeight='normal' color='text.light'>
              {item}
            </Typography>
          </li>
        )}
      </ul>
    </CustomBox>
  );
};

export default ProviderWhoITreat;
